export default {
    DEV_KEY: 'lpoFRMifdbFdurOPEBJjD5bTbJpgttW3',
    PROD_KEY: 'KuVyis8zpJQhSetIVMoK04XzvB1bA1QC',
}
